import axios from '../../../helpers/custom-axios';
import { confirmation, notify } from '../../../helpers/notifications';

export async function createGroup(parentFormID, parentSubmissionID) {
  return axios
    .post(`/manage/groups`, {
      parent_form_id: parentFormID,
      parent_submission_id: parentSubmissionID,
    })
    .then((res) => {
      notify.success('Group Created', { showOnlyTheLastOne: false });
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
}

export async function fetchGroup(groupID) {
  return axios
    .get(`/manage/groups/${groupID}`)
    .then((res) => res)
    .catch((error) => error);
}

export async function linkSubmission(groupID, submissionID) {
  return axios
    .post(`/manage/submission_groups`, {
      group_id: groupID,
      submission_id: submissionID,
    })
    .then((res) => {
      notify.success('Submission linked', { showOnlyTheLastOne: false });
      return res;
    })
    .catch((err) => {
      notify.failure('Failed to link', { showOnlyTheLastOne: false });
      return err;
    });
}

export async function unlinkSubmission(submissionGroupID, callback) {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/submission_groups/${submissionGroupID}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
}

export async function destroyGroup(groupID, callback) {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/groups/${groupID}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
}
